module.exports = __webpack_public_path__ + "img/n8.4e4a992a.jpg";